<template>
 <div v-bind:key="accessorio.id" 
               class="elemento_carrello w-100">
            <div class="row m-0 p-0">
              <div @click="$emit('elimina')" class="col-12 m-0 p-0 mt-1 pr-2" style="text-align:right; font-size:9px; color:#cccccc;">
              X
              </div>
            </div>
            <div class="container pb-2 px-4 ">
              <div class="row" v-on:click="tab_attivo = 'accessori'">
                <div class="col-2 m-0 p-0 d-flex align-items-center">
                  <div v-if="accessorio.quantita>1"class="qty">{{ accessorio.quantita }}
                  </div>
                    <img class="mx-auto" :src="getImageUrl(accessorio)" style="height:40px; width:auto;">
                </div>
                
                <div class="col-6 d-flex align-items-center align-self-center" style="color:#494949; backgroun-color:red;">
                      {{ accessorio.value }}
                </div>
                
                <div class="p-0 col-4 w-100">
                  <div class="container">
                    <div class="row">
                      <div class="col-5 p-0">
                      </div>
                      <div class="col-7 p-0">
                        <div @click.stop="" class="tot_rep">
                          <money @keydown.native="kill_debounce()" v-model="parziale_scontato" v-bind="money"></money>
                        </div>
                        <div class="earn">
                          {{ utile }} €
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </div>
</template>
<script>
	import { db } from '@/components/Firebase_Conn';
	import { ref } from '@/components/puntatori';
	import { Money } from 'v-money'

	export default {
  		name: 'elementoCarrelloAcc',
  		 beforeDestroy() {
  		 	this.distrutto = true
  		},
  		filters: {
  			virgolaDecimale: function (value) {
  			if (!value) return ''
  			value = value.toString()
    		value = value.replace('.', ',')
    		return(value)
 			},
 			toFixedIfNecessary(value){
  		 		if(Math.round(value) !== value) {
            		value = value.toFixed(2);
            	}
        		return(value)
         	}
		},
   		data: function () {
    		return {
    			sconto: '0',
      		delay_aggiornamento_sconto: '',
      		mostra_sconto: false,
      		distrutto: false,
      		money: {
      			decimal: ',',
        		thousands: '.',
        		prefix: '',
        		suffix: ' €',
        		precision: 2,
        		masked: false
      		},
    		}
  		},
  		components: {
   			Money
   		},
  		methods: {
			kill_debounce(){
				let self = this
				clearTimeout(self.delay_aggiornamento_sconto)
			},
         	sommaArray(arr,variabile){
				let risultato

         		risultato = arr.reduce(function(foo, bar){
          			if (!foo) {
            			foo = 0
          			}
          			let tot = parseFloat(foo) + parseFloat(bar[variabile
          				])
          			return tot.toFixed(2)
      			}, '')
        		return(risultato)
  			},
			getImageUrl(oggetto) {
			let estensione = oggetto.img_name.substr( oggetto.img_name.length - 4, 4)
      		let img_name = oggetto.img_name.substr(0,  oggetto.img_name.length - 4)
			if(oggetto.img_name !== null)
        	if(oggetto.fonte === 'interno' && estensione === ".ext")
          		return ref.urlBucketEsterno + oggetto.parent + '%2F'+ img_name +'?alt=media'
			if(oggetto.fonte === 'interno')
          		return ref.urlBucket + oggetto.parent + '%2F'+ oggetto.img_name +'?alt=media'
        	if(oggetto.fonte === 'esterno')
          		return ref.urlBucketEsterno + oggetto.parent + '%2F'+ oggetto.img_name +'?alt=media'
   			}
		},
  		props: ['accessorio', 'iva'],
  		computed: {
  			//IL TOTALE DELLE RIPARAZIONI NON SCONTATO
			parziale_pieno(){
				let risultato = this.accessorio.prezzo * this.accessorio.quantita
				this.accessorio.parziale = risultato - this.accessorio.sconto
				
        		return(risultato)
       		},
        	parziale_scontato:{
				get(){
            		return this.parziale_pieno - this.accessorio.sconto
        		},
        		//QUANDO MODIFICO: V-MODEL INTERVIENE SU SCONTO
    			set(newValue) {
    			 	this.sconto = this.parziale_pieno - newValue;
      			}
        	},
	       	utile(){
					let costo_totale = this.accessorio.costo * this.accessorio.quantita
    			let iva = parseFloat(this.iva)
    			let parziale_non_ivato = (this.parziale_scontato * 100) / parseFloat('1' + iva)
					let risultato = parziale_non_ivato - costo_totale

        		return(risultato.toFixed(2))
        	}
 		},
 		watch: {
 			'sconto'() {
 				let self = this
				this.delay_aggiornamento_sconto = setTimeout(
				function() {
					if(!self.distrutto){
          				self.accessorio.sconto = self.sconto
          			}
				}, 500)
			}
		}
	}
</script>

<style>
.qty{
  position:absolute; top:0px; right:10px;
  background-color:#fa3e3e;
  color:white;
  font-size:11px;
  font-weight:bold;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  height:17px;
  width:17px;
  line-height:17px;
  text-align:center;
  font-family:arial;
}

.descrizione-stato {
  	color: grey;
  	height: 22px;
}
.cart_detail_item {
  	padding: 0px !important;
  	text-align: center;
}
.detail_price {
  	font-size: 10px;
  	color: grey;
  	margin-top: 4px;
}
.img_cart {
  	display: block;
  	margin: 0 auto;
  	margin-top: 10px !important;
  	width: 40px;
  	height: auto;
}
.cart_detail_item {
	padding: 0px !important;
	text-align: center;
}
.stato_rip div {
	content: "";
  	display: block;
  	width: 100%;
  	height: 0;
  	padding-bottom: 100%;
  	background: #f2f2f2;
  	-moz-border-radius: 50%;
  	-webkit-border-radius: 50%;
  	border-radius: 50%;
}
.stato_rip {
  width: 100%;
  max-width: 35px;
}
.stato_rip img {
  	position: relative;
  	width: 50%;
  	left: 50%;
  	margin-left: -25%;
  	margin-top: 25%;
}
.earn {
  	font-size: 12px;
  	margin-top: 1px;
  	color: #70a157;
  	font-family: Arial;
  	text-align: center;
}
.tot_rep {
  	font-size: 18px;
  	margin-top: 5px;
  	color: #646464;
  	font-family: Arial;
  	text-align: center;
}
.tot_rep input{
  	width:100%;
  	text-align:center;
  	border:none;
  	background-color:transparent;
}
.tot_rep input:focus{
  	outline:none;
}
.parz_no_sconto{
 	position:absolute;
  	width:100%;
  	height:18px;
  	top:-18px; 
	text-align:center; 
}
.parz_no_sconto > span{
 	color:red;
 	text-decoration:line-through;
}
.parz_no_sconto span > span{
 	color:black;
}
.sconto{
	color:white;
	background-color:red;
	padding:2px;
	padding-left:4px;
	padding-right:4px;
	margin-left:8px;
	font-size:10px;
	line-height:10px;
	height:14px;
	font-weight:bold;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
}

</style>